module.exports = __webpack_public_path__ + "img/collection-weddingRingsStylesRomantic@2x.02ff677.jpg";